import { CircularProgress } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionsModalTypes } from '../../../../core/legacy/reducers/modals';
import GenericModal from '../../../legacy/components/ui/modals/GenericModal';
import { ContentContainer, ModalCenterTitle, ModalCenterSubTitle } from '../../../legacy/components/ui/modals/styles';

export const RefreshAllSessionsGradeLoading: FC = () => {
    const { t } = useTranslation();
    const options = {
        hideDefaultButtons: true,
        notDismissable: true,
    };

    return (
        <GenericModal options={options} modalType={SessionsModalTypes.REFRESH_ALL_SESSIONS_GRADE_LOADING}>
            <ContentContainer>
                <CircularProgress />
                <ModalCenterTitle>{t('networkMap.refreshAllSessionsLoading.title')}</ModalCenterTitle>
                <ModalCenterSubTitle>{t('networkMap.refreshAllSessionsLoading.subtitle')}</ModalCenterSubTitle>
            </ContentContainer>
        </GenericModal>
    );
};
